const ApiIconCustom = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();

        self.getCustomIcons();

    },
    'getCustomIcons': function(){
        let self = this;
        let customIcons = self.body.find('i.fa-custom');

        customIcons.each(function(){
            let customIcon = $(this);
            let classes = customIcon.attr('class');
            let iconNameRaw = classes.replace('fa-custom ','');
            let iconName = iconNameRaw.replace('fa-','');
            console.log(iconName);
        });

    },

    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiIconCustom.start();
});
